exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".play-button {\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  z-index: 1;\n}\n", ""]);

// exports
